export default __webpack_public_path__ + "static/media/auto-driver-user-icon.da13119e.svg";